import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { HOME_PATH } from '@/shared/config';
import { buttonVariants, PageHeading, SitePageShell } from '@/shared/ui';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

/** 탈퇴 완료(/withdrawn) — 공개 화면. 세션이 이미 비워진 뒤에 열린다. */
export const WithdrawnPage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-16 sm:pt-24">
    <div className="flex flex-col items-start gap-8">
      <PageHeading title="탈퇴가 완료되었어요" description="그동안 이용해 주셔서 감사합니다." />
      <Link to={HOME_PATH} className={buttonVariants({ size: 'lg' })}>
        홈으로
      </Link>
    </div>
  </SitePageShell>
);
